import { render } from "./SearchOnTask.vue?vue&type=template&id=5c49f44a&scoped=true"
import script from "./SearchOnTask.vue?vue&type=script&lang=js"
export * from "./SearchOnTask.vue?vue&type=script&lang=js"

import "./SearchOnTask.vue?vue&type=style&index=0&id=5c49f44a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c49f44a"]])

export default __exports__